export const getFlyAnywhere = (store) => store.flyAnywhere;
export const getFlyAnywhereCountries = (store) => store.flyAnywhere?.countries;
export const getFlyAnywhereDestination = (store) => store.flyAnywhere?.destination;
export const getFlyAnywhereFromCityName = (store) => store.flyAnywhere?.fromCity?.translatedCityName;
